<template>
  <div class="content">
    <!-- 筛选查询框 -->
    <!-- 筛选查询框 -->
    <el-form :inline="true" class="demo-form-inline" size="mini">
      <el-form-item>
        <el-input v-model="orderNumber" placeholder="请输入订单号" style="width:250px" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="shareUserId"
          :disabled="isRole"
          placeholder="请输入分享者id"
          style="width:250px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="userId" placeholder="请输入购买用户id" style="width:250px" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="seleteshareByNameBtn">搜索</el-button>
      </el-form-item>
    </el-form>
    <!-- 商品表格 -->
    <div style="height:80%">
      <el-table
        :data="orderArr"
        style="width: 100%"
        height="100%"
        v-loading="loading"
        :header-cell-style="{background:'#e8effc', color:'#000'}"
      >
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column label="订单号">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{scope.row.orderNumber }}</span>
          </template>
        </el-table-column>

        <el-table-column label="分享者（id）" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.shareUserId===0?'/':scope.row.shareUserId}}</span>
          </template>
        </el-table-column>
        <el-table-column label="购买用户（id）" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.userId}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="订单号" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.orderNumber}}</span>
          </template>
        </el-table-column>-->
        <el-table-column label="奖励(积分)" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.reward}}</span>
          </template>
        </el-table-column>
        <el-table-column label="时间" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.createTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <!-- <el-button size="mini" @click="ejectupdataGoods(scope.row)">订单详情</el-button> -->
            <el-button size="mini" type="danger" @click="deleteShareBtn(scope.row.id)" :disabled="isRole">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        @prev-click="prevClick"
        @next-click="nextClick"
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :total="pageCount"
      ></el-pagination>-->
    </div>
  </div>
</template>

<script>
import {
  seleteshareByid,
  deleteShare,
  seleteshareByName
} from "@/services/vipCard";
export default {
  data() {
    return {
      orderArr: [],
      loading: true,
      name: "",
      expressNumber: "",
      form: "",
      pageCount: "",
      pageSize: 8,
      dialogFormVisible: false,
      orderNumber: "",
      shareUserId: "",
      userId: "",
      isRole: false
    };
  },
  created() {
    console.log("------------加载--------------userId-------",this.$store.state.supUser.userId);
    if (this.$store.state.supUser.role_id == 0) {
      this.isRole = false;
      // 查询分享记录 不传id查所有
      seleteshareByid(1).then(res => {
        console.log(res);
        this.orderArr = res.data;
        this.loading = false;
      });
    } else {
      this.shareUserId = this.$store.state.supUser.userId;
      this.isRole =true ;
      this.seleteshareByNameBtn();
    }
  },
  methods: {
    seleteshareByNameBtn() {
      if (
        this.shareUserId == "" &&
        this.orderNumber == "" &&
        this.userId == ""
      ) {
        this.select();
        return;
      }
      seleteshareByName(this.userId, this.shareUserId, this.orderNumber).then(
        res => {
          this.orderArr = res.data;
            this.loading = false;
        }
      );
    },
    select() {
      // 查询订单数据
      seleteshareByid(0).then(res => {
        console.log(res);
        this.orderArr = res.data;
        this.loading = false;
      });
    },

    ejectupdataGoods(row) {
      console.log(row);
      this.dialogFormVisible = true;
    },
    deleteShareBtn(id) {
      this.$confirm("此操作将永久删除该用户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          console.log(id);
          deleteShare(id).then(res => {
            console.log(res);
            this.select();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style scoped>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.addressDetail:hover {
  cursor: pointer;
}
</style>